import type { ZodType } from 'zod';

import { icsApi } from './api';

type Params<T> = {
  url: string;
  body: FormData;
  schema?: ZodType<T>;
};

export async function postForm<T>({ url, body, schema }: Params<T>): Promise<T> {
  const axiosResponse = await icsApi.post(url, body);

  if (axiosResponse.status !== 200) {
    throw new Error(axiosResponse.statusText);
  }

  if (schema) {
    const response = schema.safeParse(axiosResponse.data);
    if (!response.success) {
      throw new Error(response.error.message);
    }

    return response.data;
  }

  return axiosResponse.data;
}
